var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExamplesIconItem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 5.52344H8.22391",
    stroke: "#CE5AD6",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 8.04102H6.19681",
    stroke: "#CE5AD6",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0191 12.7465C9.69962 13.066 9.2814 13.2679 8.83254 13.3193L7.18989 13.5075C7.12595 13.5149 7.07183 13.4607 7.07916 13.3968L7.26737 11.7541C7.3188 11.3053 7.52069 10.8871 7.84015 10.5676L12.3193 6.08847C12.921 5.48677 13.8965 5.48677 14.4982 6.08846C15.0999 6.69016 15.0999 7.6657 14.4982 8.2674L10.0191 12.7465Z",
    stroke: "#CE5AD6",
    strokeWidth: 1.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExamplesIconItem);
export default __webpack_public_path__ + "static/media/examples-icon-item.2abf4ce4476e566f6f1c3f6fa2640160.svg";
export { ForwardRef as ReactComponent };